import { useState } from "react";
import { Box, Text } from "@chakra-ui/react";

const ToggleButton = ({ expanded, onClick, color }) => (
  <Box
    as="button"
    type="button"
    onClick={onClick}
    aria-expanded={expanded}
    fontSize="xs"
    fontWeight="600"
    color={color}
    textDecoration="underline"
    cursor="pointer"
    bg="transparent"
    border="none"
    p={0}
    whiteSpace="nowrap"
  >
    {expanded ? "Show less" : "Read more"}
  </Box>
);

// General disclaimer: the whole UI is a demonstration mock-up, not the
// final or agreed design. Shown on every view, including the login page.
export const GeneralDisclaimerBanner = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      role="note"
      bg="yellow.50"
      borderBottom="1px solid"
      borderColor="yellow.300"
      px={{ base: 4, md: 8 }}
      py={2}
    >
      <Text fontSize="xs" color="gray.700">
        <Text as="span" fontWeight="700">Demonstration mock-up</Text>
        {" "}for illustration purposes only. This interface does not represent
        the final or agreed design and is subject to change.{" "}
        <ToggleButton
          expanded={expanded}
          onClick={() => setExpanded((v) => !v)}
          color="gray.700"
        />
      </Text>
      {expanded && (
        <Box mt={2} maxW="900px">
          <Text fontSize="xs" fontWeight="700" color="gray.700" mb={1}>
            Demonstration Interface — Not a Final Product
          </Text>
          <Text fontSize="xs" color="gray.700">
            This user interface is a demonstration mock-up provided for
            illustration and discussion purposes only. The screens, workflows,
            terminology, and data presented here are examples and do not
            represent the final design, functionality, or scope of the system.
            All content is subject to change without notice, and nothing shown
            in this interface constitutes an agreed, approved, or contractual
            baseline.
          </Text>
        </Box>
      )}
    </Box>
  );
};

// Special disclaimer for the Data Tailor customization section: the
// guardrailing approach (options, restrictions, validation) is an
// exploratory proposal, not an agreed capability.
export const DataTailorDisclaimer = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      role="note"
      bg="yellow.50"
      border="1px solid"
      borderColor="yellow.300"
      borderRadius="md"
      px={3}
      py={2}
      mb={4}
    >
      <Text fontSize="xs" color="gray.700">
        <Text as="span" fontWeight="700">Exploratory proposal:</Text>
        {" "}the Data Tailor customization shown here is an exploratory
        proposal for guiding user input. It is not an agreed or final
        capability and is subject to revision or removal.{" "}
        <ToggleButton
          expanded={expanded}
          onClick={() => setExpanded((v) => !v)}
          color="gray.700"
        />
      </Text>
      {expanded && (
        <Text fontSize="xs" color="gray.700" mt={2}>
          The customization capabilities presented in this section — including
          product selection, format and projection options, chained
          transformation steps, and the associated validation rules — are an
          exploratory proposal. Their purpose is to illustrate one possible
          approach to guiding and constraining user input when configuring
          Data Tailor processing. The options offered, the restrictions
          applied, and the overall behavior of this section have not been
          reviewed or agreed by the project stakeholders, do not represent a
          committed capability, and are subject to substantial revision or
          removal.
        </Text>
      )}
    </Box>
  );
};
